import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { CLINPricingEditor } from './CLINPricingEditor';
import { IndirectRatePanel } from './IndirectRatePanel';
import { OverviewPanel } from './OverviewPanel';
import { RateCardEditor } from './RateCardEditor';
import { SharedTierEditor } from './SharedTierEditor';
function laborColumns() {
    return [
        {
            key: 'label',
            label: 'Labor Category',
            parameterName: 'label',
            editable: false,
            perPeriod: false
        },
        {
            key: 'ftes',
            label: 'FTEs',
            parameterName: 'ftes',
            editable: true,
            perPeriod: false
        },
        {
            key: 'hours',
            label: 'Hours',
            parameterName: 'hours',
            editable: true,
            perPeriod: false
        },
        {
            key: 'rate',
            label: 'Rate',
            parameterName: 'rate',
            editable: false,
            perPeriod: false
        },
        {
            key: 'total',
            label: 'Total',
            parameterName: 'total',
            editable: false,
            perPeriod: false
        }
    ];
}
export const CenterEditor = /*#__PURE__*/ memo(function CenterEditor({ projectId, selectedNodeId, pricing, clinPricing, rateCard, sharedTierConfigs, indirectConfig, onCLINChange, onRateCardChange, onIndirectConfigChange, onSharedTierChange, onSelectNode }) {
    // Overview
    if (selectedNodeId === 'overview') {
        return /*#__PURE__*/ _jsx(OverviewPanel, {
            pricing: pricing,
            clinPricing: clinPricing,
            sharedTierConfigs: sharedTierConfigs
        });
    }
    // Rate Card
    if (selectedNodeId === 'rate-card') {
        if (!rateCard) {
            return /*#__PURE__*/ _jsx("div", {
                className: "text-sm text-gray-400 py-8 text-center",
                children: "No rate card available for this scenario."
            });
        }
        return /*#__PURE__*/ _jsx(RateCardEditor, {
            rateCard: rateCard,
            projectId: projectId,
            scenarioId: pricing.id,
            onChange: onRateCardChange
        });
    }
    // Indirect Rates
    if (selectedNodeId === 'indirect') {
        return /*#__PURE__*/ _jsx(IndirectRatePanel, {
            config: indirectConfig,
            onChange: onIndirectConfigChange
        });
    }
    // Shared Tier
    if (selectedNodeId.startsWith('shared-tier-')) {
        const configId = selectedNodeId.replace('shared-tier-', '');
        const config = sharedTierConfigs.find((c)=>c.id === configId);
        if (!config) {
            return /*#__PURE__*/ _jsx("div", {
                className: "text-sm text-gray-400 py-8 text-center",
                children: "Shared tier not found."
            });
        }
        // Find CLINs referencing this tier
        const referencingClins = clinPricing.filter((clin)=>{
            if (clin.laborStructure.type !== 'tiered_shared') return false;
            return clin.laborStructure.tierRefs.some((ref)=>ref.sharedTierConfigId === configId);
        }).map((c)=>c.clinNumber);
        return /*#__PURE__*/ _jsx(SharedTierEditor, {
            config: config,
            rateCard: rateCard,
            columns: laborColumns(),
            referencingClins: referencingClins,
            allSharedTierConfigs: sharedTierConfigs,
            onChange: onSharedTierChange
        });
    }
    // CLIN editor
    const selectedClin = clinPricing.find((c)=>c.clinNumber === selectedNodeId);
    if (selectedClin) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "space-y-2",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ _jsxs("h2", {
                            className: "text-lg font-semibold text-gray-900",
                            children: [
                                "CLIN ",
                                selectedClin.clinNumber
                            ]
                        }),
                        selectedClin.metadata.title && /*#__PURE__*/ _jsx("span", {
                            className: "text-sm text-gray-500 truncate",
                            children: selectedClin.metadata.title
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(CLINPricingEditor, {
                    clinPricing: selectedClin,
                    rateCard: rateCard,
                    sharedTierConfigs: sharedTierConfigs,
                    onChange: onCLINChange,
                    onSelectNode: onSelectNode
                })
            ]
        });
    }
    // Fallback
    return /*#__PURE__*/ _jsx("div", {
        className: "text-sm text-gray-400 py-8 text-center",
        children: "Select an item from the tree to edit."
    });
});
